/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

const stylesIdMap = {
  code: {
    width: 80,
  },
  leg: {
    width: 45,
  },
  trailer: {
    width: 80,
  },
  srv: {
    width: 32,
  },
  miles: {
    width: 70,
  },
  notes: {
    width: 32,
  },
  alerts: {
    width: 32,
  },
  watched: {
    width: 32,
  },
  carrier: {
    width: 150,
  },
};

const getLeft = (prevColumn) =>
  stylesIdMap[prevColumn].left + stylesIdMap[prevColumn].width + 16; // padding

const columnsOrder = [
  "code",
  "leg",
  "trailer",
  "srv",
  "miles",
  "notes",
  "alerts",
  "watched",
  "carrier",
];

columnsOrder.forEach((column, index) => {
  let left = 0;
  if (index > 0) {
    const prevColumn = columnsOrder[index - 1];
    left = getLeft(prevColumn);
  }
  stylesIdMap[column].left = left;
});

export default stylesIdMap;
